var base = require('settings/teams/batch-search-settings');

Vue.component('spark-batch-search-settings', {
    mixins: [base]
});
